export default {
  color: {
    textColor: "black",
    background: "white",
    chip: "#E9E9E9",
    mainBackground: "whitesmoke",
  },
};
